// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import { Tab, Nav, Button, Modal, Form } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import SVG from 'react-inlinesvg';
// CUSTOM COMPONENTS
// SERVICES AND HELPERS
import * as jobUploadFormService from '../../../../../../services/form/jobUploadFormService';
import { toAbsoluteUrl } from '../../../../../../_metronic/_helpers';
import { FilterNoneRounded } from '@material-ui/icons';
//STYLES AND ASSETS

const DailyFormsListingTable = (props) => {
  const {
    dailyForms,
    showConfirmModal,
    auth,
    history,
    fetchDailyForms,
    determineAndStartForm,
    unsubmitForm,
    determineAndSetFormAsNA,
  } = props;
  const [status, setStatus] = useState('to-do');
  const [showNAModal, setShowNAModal] = useState(false);
  const [dailyFormOnSpecificIndex, setDailyFormOnSpecificIndex] = useState({});
  const [filteredDailyForms, setFilteredDailyForms] = useState(dailyForms);

  useEffect(() => {
    if (dailyForms) {
      if (status === 'to-do') {
        setFilteredDailyForms(dailyForms.filter((x) => x.status !== 'Completed'));
      } else if (status === 'completed') {
        setFilteredDailyForms(dailyForms.filter((x) => x.status === 'Completed'));
      } else {
        setFilteredDailyForms(dailyForms);
      }
    }
  }, [status, dailyForms]);

  const columns = [
    {
      name: 'id',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        width: 15,
        download: false,
        setCellProps: () => ({
          'data-aes-field': 'actions',
          'data-aes-label': 'Actions',
          style: { width: '30%' },
        }),
        customBodyRenderLite: (dataIndex) => {
          return (
            <div className='aes-admin-listing-actions'>
              <button
                // disabled={filteredDailyForms[dataIndex].isNotApplicable}
                className='btn btn-sm btn-primary font-weight-bold py-2 px-3 px-xxl-5 my-1'
                onClick={() => {
                  !filteredDailyForms[dataIndex].isNotApplicable
                    ? filteredDailyForms[dataIndex].status === 'Completed'
                      ? determineAndStartForm({ ...filteredDailyForms[dataIndex], frequency: 'DAILY' }, false)
                      : determineAndStartForm({ ...filteredDailyForms[dataIndex], frequency: 'DAILY' }, true)
                    : handleSetJobFormAsNA(dataIndex);
                }}
              >
                {!filteredDailyForms[dataIndex].isNotApplicable
                  ? filteredDailyForms[dataIndex].status === 'Completed'
                    ? 'View'
                    : 'Fill'
                  : 'View Reason'}
              </button>
              {auth.isAdmin && (
                <button
                  disabled={
                    filteredDailyForms[dataIndex].isNotApplicable || (!auth.isAdmin && filteredDailyForms[dataIndex].status === 'Pending')
                  }
                  className='btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5 my-1'
                  onClick={() => determineAndStartForm({ ...filteredDailyForms[dataIndex], frequency: 'DAILY' }, true)}
                >
                  {'Edit'}
                </button>
              )}
              {filteredDailyForms[dataIndex].status !== 'Completed' && (
                <button
                  disabled={filteredDailyForms[dataIndex].isNotApplicable}
                  onClick={
                    () => handleSetJobFormAsNA(dataIndex)
                    //     showConfirmModal({
                    //     title: "Mark N/A",
                    //     text: "Are you sure you want to mark this form as N/A?  Once Marked N/A this form will not be accessible.",
                    //     rightBtnText: "Confirm",
                    //     btnAction: () => determineAndSetFormAsNA({ ...filteredDailyForms[dataIndex], frequency: "DAILY" })
                    // })
                  }
                  className='btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1'
                >
                  N/A
                </button>
              )}
              {(auth.isAdmin || auth.isProjectManager) && (
                <button
                  disabled={
                    filteredDailyForms[dataIndex].status !== 'Completed' || filteredDailyForms[dataIndex].isNotApplicable ? true : false
                  }
                  className='btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1'
                  onClick={() => unsubmitForm(dailyForms[dataIndex].id)}
                >
                  {'Unsubmit'}
                </button>
              )}
              <Modal
                centered
                size='lg'
                show={showNAModal}
                onHide={() => {
                  handleModalClose();
                }}
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    Are you sure you want to mark this form as N/A? Once Marked N/A this form will not be accessible.
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {
                    // filteredDailyForms[dataIndex].reasonForNA ?
                    //     <p>{filteredDailyForms[dataIndex].reasonForNA}</p> :
                    <div className='form-group row'>
                      <div className='col-lg-12 col-xl-12'>
                        <label>Please enter the reason for N/A selection in the text box below</label>
                      </div>
                      <div className='col-lg-12 col-xl-12'>
                        <div className='input-group input-group-lg input-group-solid'>
                          <Form.Control
                            as='textarea'
                            rows='7'
                            placeholder='Enter N/A Reason'
                            className={`form-control form-control-lg form-control-solid`}
                            name='rejectionReason'
                            disabled={dailyFormOnSpecificIndex.isNotApplicable}
                            value={dailyFormOnSpecificIndex.reasonForNA}
                            onChange={(e) => {
                              setDailyFormOnSpecificIndex({ ...dailyFormOnSpecificIndex, reasonForNA: e.target.value });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  }
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant='secondary'
                    onClick={() => {
                      handleModalClose();
                    }}
                  >
                    Close
                  </Button>
                  {!dailyFormOnSpecificIndex.isNotApplicable && (
                    <button
                      type='submit'
                      className='btn btn-success mr-2'
                      disabled={!dailyFormOnSpecificIndex.reasonForNA}
                      onClick={() => {
                        determineAndSetFormAsNA({ ...dailyFormOnSpecificIndex, frequency: 'DAILY' });
                        handleModalClose();
                      }}
                    >
                      Confirm and Submit Reason
                    </button>
                  )}
                </Modal.Footer>
              </Modal>
            </div>
          );
        },
      },
    },
    {
      name: 'name',
      label: 'Name',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'primary',
          'data-aes-label': 'Form Name',
        }),
      },
    },
    {
      name: 'date',
      label: 'Form Date',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'secondary-one',
          'data-aes-label': 'Form Date',
        }),
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'secondary-two',
          'data-aes-label': 'Status',
        }),
      },
    },
    {
      name: 'isNotApplicable',
      label: 'N/A?',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'detail',
          'data-aes-label': 'N/A?',
          style: { width: '5%' },
        }),
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <SVG
                className='h-50 align-self-center'
                src={toAbsoluteUrl(
                  filteredDailyForms[dataIndex].isNotApplicable
                    ? '/media/svg/icons/Navigation/Check.svg'
                    : '/media/svg/icons/Navigation/Close.svg',
                )}
              ></SVG>
            </>
          );
        },
      },
    },
  ];

  const handleSetJobFormAsNA = (index) => {
    setShowNAModal(true);
    setDailyFormOnSpecificIndex({ ...filteredDailyForms[index], frequency: 'ONCE' });
  };

  const handleModalClose = () => {
    setShowNAModal(false);
    setDailyFormOnSpecificIndex({});
  };

  return (
    <div className='mb-10 aes-admin-listing-page aes-admin-listing-page--job-forms aes-admin-listing-page--job-forms-daily'>
      <div className='card-toolbar'>
        <Tab.Container defaultActiveKey={status}>
          <Nav as='ul' onSelect={(_status) => setStatus(_status)} className='nav nav-pills nav-pills-sm nav-dark-75'>
            <Nav.Item className='nav-item' as='li'>
              <Nav.Link eventKey='to-do' className={`nav-link py-2 px-4 ${status === 'to-do' ? 'active' : ''}`}>
                To-do
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className='nav-item' as='li'>
              <Nav.Link eventKey='completed' className={`nav-link py-2 px-4 ${status === 'completed' ? 'active' : ''}`}>
                Completed
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className='nav-item' as='li'>
              <Nav.Link eventKey='all' className={`nav-link py-2 px-4 ${status === 'all' ? 'active' : ''}`}>
                All
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Tab.Container>
      </div>
      <div className='aes-admin-listing px-0'>
        <h3 className='card-label font-size-h3 font-weight-bolder text-dark mt-20'>Daily Forms</h3>
        <MUIDataTable
          className='aes-admin-listing-surface'
          data={filteredDailyForms}
          columns={columns}
          options={{
            responsive: 'standard',
            rowsPerPage: 10,
            selectableRows: 'none',
            setTableProps: () => ({
              className: 'aes-admin-listing-table',
            }),
          }}
        />
      </div>
    </div>
  );
};

export default DailyFormsListingTable;
